var path = '/card/component/tpl/app-vcard-image-promo.html';
var html = "<div class=vcard-image-promo-container ng-style=$ctrl.styles.container> <section class=vcard-image-promo> <div class=media> <a ng-href={{::$ctrl.vcardImagePromoLink}} target={{::$ctrl.vcardLinkTarget}} ng-click=\"$ctrl.trackEvent('Content Converted', {'event trigger': $ctrl.eventTrigger, 'event trigger detail': $ctrl.eventTriggerDetail})\"> <img ng-src={{::$ctrl.item.app.image_promo_src}} err-src={{::$ctrl.parent.imageDefault}} alt={{::$ctrl.altText}} /> </a> </div> </section> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/card/component/tpl/app-vcard-image-promo.html
// module id = 204
// module chunks = 1 2 3 4